import { createContext, ReactElement, ReactNode, useContext } from 'react';
import { ECasinoGameMode } from 'interfaces/casino-data';
import { NewCasinoGame } from 'interfaces/new-casino';

export interface ICasinoOpenGameConfigsProps {
  onOpenGame?: (game: NewCasinoGame, mode: ECasinoGameMode) => void;
}

export interface ICasinoOpenGameConfigsProviderProps {
  children: ReactNode;
  value: ICasinoOpenGameConfigsProps;
}

const CasinoOpenGameConfigsContext = createContext<
  ICasinoOpenGameConfigsProviderProps['value']
>({});

export const CasinoOpenGameConfigsProvider = (
  props: ICasinoOpenGameConfigsProviderProps
): ReactElement => {
  return (
    <CasinoOpenGameConfigsContext.Provider value={props.value}>
      {props.children}
    </CasinoOpenGameConfigsContext.Provider>
  );
};

export const useCasinoOpenGameConfigsValues =
  (): ICasinoOpenGameConfigsProviderProps['value'] => {
    return useContext(CasinoOpenGameConfigsContext);
  };
